export const invitationAuthOptions = (mode, email = "") => {
  const loginHint = email.trim();
  if (mode !== "signUp") {
    return loginHint
      ? { prompt: "login", loginHint }
      : { prompt: "select_account" };
  }
  return { prompt: "create" };
};
